var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import log from './whisper';
/**
 * Exports an allytm class with an event method. It abstracts the access
 * and invocation of the global variable and provide TS support for all events and arguments.
 */
var allytm = /** @class */ (function () {
    function allytm() {
    }
    allytm.event = function (type) {
        var _a;
        var options = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            options[_i - 1] = arguments[_i];
        }
        try {
            ;
            (_a = window.allytm).event.apply(_a, __spread([type], options));
        }
        catch (e) {
            var error = e;
            log.error({
                message: [
                    "Analytics failed to register " + type + " event: ",
                    error.message,
                    error.stack,
                ],
            });
        }
    };
    return allytm;
}());
export { allytm };
//# sourceMappingURL=allytm.js.map